import PreviousCareRepeater from "../casesummary/sections/previouscare/PreviousCareRepeater";
import classes from './outsidelien/OutsideLiens.module.css'

export default function PreviousCareNegotiation({apiCase, permissionType}) {
    return <div style={{flex: 1}}>
        <div className={classes.header} style={{minHeight: 28}}>
            <h3>Previous Care</h3>
            {/* <Button click={openModalHandler}><i className="ti ti-square-plus"></i>add new</Button> */}
        </div>
        <PreviousCareRepeater apiCase={apiCase} permissionType={permissionType}/>
    </div>
}